import React, { useState } from 'react';
import { ListItemText, ListItem, ListItemButton, ListItemSecondaryAction, IconButton } from '@mui/material';
import { Link, useHistory } from 'react-router-dom';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

export default function ListItemLink({ primary, to, disabled, classes, add = false }) {
  const history = useHistory();
  const [visible, setVisible] = useState(false)
  const renderLink = React.forwardRef((props, ref) => (<Link ref={ref} to={to} {...props} />))
  const handleClick = () => {
    history.push(to + '/add')
  }
  const handleMouseOut = () => { setVisible(false) }
  const handleMouseOver = () => { setVisible(true) }
  return (
    < >
      <ListItem
        className={classes}
        onMouseEnter={handleMouseOver}
        onMouseLeave={handleMouseOut}
        secondaryAction={
          (add && visible) && <ListItemSecondaryAction onMouseEnter={handleMouseOver} onMouseLeave={handleMouseOut}>
            <IconButton edge="end" onClick={handleClick} size="large">
              <AddCircleOutlineIcon color='primary' />
            </IconButton>
          </ListItemSecondaryAction>
        }
        disablePadding
      >
        <ListItemButton component={renderLink} disabled={disabled}>
          <ListItemText primary={primary} />
        </ListItemButton>
      </ListItem>
    </>
  );
}